<template>

    <LoopItemPanel title="Slide">

        <div class="canvas-blocks-custom-projectSlider-LoopItemPanel">

            <div class="m-5">

                <div class="mb-1 text-gray-600 label2">Welk project tonen?</div>

                <small class="block mb-3 text-gray-500 label2 text-muted">
                    Kies hier het project wat getoond dient te gaan worden.
                </small>

                <v-select
                    :options="paginated"
                    :filterable="false"
                    label="name"
                    :value="loopItem.project"
                    @input="(project) => updateProject(project)"
                    @search="onSearch"
                    @open="onOpen"
                    @close="onClose"
                >
                    <div slot="no-options">Geen opties</div>

                    <template #option="{ id, name }">
                        {{ name.nl }}
                    </template>

                    <template #selected-option="{ id, name }">
                        {{ name.nl }}
                    </template>

                    <template #list-footer>
                        <li v-show="hasNextPage" ref="load" class="loader">
                            Meer opties laden...
                        </li>
                    </template>
                </v-select>
            </div>

        </div>

        <template v-slot:actionsExtra>
            <button class="btn btn-success" @click="save">
                <i class="mr-2 fas fa-check"></i> Opslaan
            </button>
        </template>

    </LoopItemPanel>

</template>

<script>

import LoopItemPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/loop/LoopItemPanel";
import Treeselect from '@riophae/vue-treeselect';
import axios from '@galaxy/modules/Core/resources/js/axiosBuilder';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {

    extends: LoopItemPanel,

    components: {
        LoopItemPanel,
    },

    data() {
        return {
            projects: [],
            observer: null,
            limit: 10,
            search: '',
        }
    },

    created()
    {
        this.loadProjects();
    },

    mounted()
    {
        this.observer = new IntersectionObserver(this.infiniteScroll)
    },

    computed: {
        // TODO Low: No support for multi language
        filtered() {
            return this.projects.filter((project) => project.name.nl.toLocaleLowerCase().includes(this.search.toLocaleLowerCase()));
        },
        paginated() {
            return this.filtered.slice(0, this.limit);

            // console.log(
            //     !this.search,
            //     !filtered.find((product) => product.id === this.loopItem.product),
            //     this.loopItem.product,
            //     this.products.find((product) => product.id === this.loopItem.product)
            // );
            // console.log( filtered );
            // if( !this.search && !filtered.find((product) => product.id === this.loopItem.product) ) {
            //     filtered.push(this.products.find((product) => product.id === this.loopItem.product));
            // }
            // console.log( filtered );

            return filtered;
        },
        hasNextPage() {
            return this.paginated.length < this.filtered.length;
        },
    },

    methods: {

        async loadProjects()
        {
            this.projects = (await axios.get(this.adminUrlPrefix + '/getProjects')).data;
        },

        updateProject(project)
        {
            this.$set(this.loopItem, 'project', {
                id: project.id,
                name: project.name,
            });
        },

        onSearch(query)
        {
            this.search = query;
        },

        async onOpen()
        {
            if (this.hasNextPage) {
                await this.$nextTick()
                this.observer.observe(this.$refs.load)
            }
        },

        onClose()
        {
            this.observer.disconnect()
        },

        async infiniteScroll([{ isIntersecting, target }])
        {
            if (isIntersecting) {
                const ul = target.offsetParent
                const scrollTop = target.offsetParent.scrollTop
                this.limit += 10
                await this.$nextTick()
                ul.scrollTop = scrollTop
            }
        },
    },

}
</script>

<style lang="scss">
    .canvas-blocks-custom-products-LoopItemPanel {
        .v-select {
            .vs__dropdown-menu {
                position: sticky;
            }
        }
    }
</style>

<style lang="scss" scoped>

.loader {
    text-align: center;
    color: #bbbbbb;
}
</style>
